import { useDatabase } from "@nozbe/watermelondb/hooks";
import { useCallback, useEffect, useState } from "react";
import { View, Text } from "react-native-ui-lib";
import { FlatActionList } from "@towersystems/roam-common-native";
import { Page } from "@towersystems/roam-common-native";
import Sale from "../../../../utilities/data/model/Sale";
import { Q } from "@nozbe/watermelondb";
import { formatDateToCalendar } from "../../../../utilities/date/format-date";
import { SettingsRootParamList } from "../../../../types";
import { NativeStackScreenProps } from "@react-navigation/native-stack";
import { useFocusEffect } from "@react-navigation/native";

export type OfflineSalesListScreenProps = NativeStackScreenProps<
  SettingsRootParamList,
  "OfflineSalesListScreen"
>;

export const OfflineSalesListScreen = ({
  navigation,
}: OfflineSalesListScreenProps) => {
  const [sales, setSales] = useState<Sale[] | undefined>(undefined);

  const database = useDatabase();

  useFocusEffect(
    useCallback(() => {
      database.collections
        .get<Sale>("sales")
        .query(Q.where("sync_state", Q.oneOf(["UPLOAD"])))
        .fetch()
        .then((i) => setSales(i))
        .catch((err) => console.log(err));
    }, [])
  );

  const items =
    sales?.map((sale) => ({
      key: sale.id,
      title: `#${sale.invoiceNumber}`,
      onPress: () =>
        navigation.navigate("SaleInQueueOptionsScreen", { saleId: sale.id }),
      subTitle: (
        <View>
          <Text style={{ opacity: 0.6, fontSize: 12 }}>
            {sale.lastSyncAttempt
              ? formatDateToCalendar(sale.lastSyncAttempt.toString())
              : "Never synced"}
          </Text>
        </View>
      ),
    })) || [];

  const emptyMarkup =
    sales !== undefined && sales.length === 0 ? (
      <View>
        <Text>No sales in queue</Text>
      </View>
    ) : undefined;

  return (
    <Page title="Sales Queue">
      <FlatActionList items={items}></FlatActionList>
      {emptyMarkup}
    </Page>
  );
};
